import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import "./styles/App.css";
import "./styles/stretchfont.css";
import Home from "../views/home";
import { PageView } from "../ga-tracker";
import {
  fetchClient,
  fetchClientBranding,
  fetchClientNetwork
} from "../state/client/actions";
import { getItemFromLS } from "../utils/util";
import { EVENTS, LOGIN, SCHEDULED } from "../constants";
import { loginSso, logout, storeNextUrl } from "../state/user/actions";
import Axios from "../utils/axios";
import LoadingState from "../utils/LoadingState";

const propTypes = {
  config: PropTypes.object,
  loadingState: PropTypes.instanceOf(LoadingState)
};

function App({ config, loadingState }) {
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const { loggedIn } = useSelector((state) => state.user);

  useEffect(() => {
    Axios.init(
      config,
      loadingState,
      history,
      () => dispatch(logout()),
      (url) => {
        dispatch(storeNextUrl(url));
      }
    );
  }, []);

  useEffect(() => {
    PageView();
    toastr.removeByType("error");
    const search = new URLSearchParams(location.search);
    if (
      !loggedIn &&
      location.search &&
      search.get("token") &&
      search.get("AccountID")
    ) {
      dispatch(
        loginSso({
          token: search.get("token"),
          accountId: search.get("AccountID"),
          redirectToLogin: () => history.push(`/${params.shortName}/${LOGIN}`)
        })
      );
    }
  }, [location]);

  useEffect(() => {
    const lsShortName = getItemFromLS("c_sh_n");
    const name = lsShortName === "null" ? JSON.parse(lsShortName) : lsShortName;
    if (!!name && !!params?.shortName && params.shortName !== name) {
      history.push(
        `/${params.shortName}/${EVENTS}/${SCHEDULED}${location.search}`
      );
    }

    dispatch(fetchClient(params.shortName));

    // Fetch client branding settings
    dispatch(fetchClientBranding(params.shortName));

    // Fetch client network
    dispatch(fetchClientNetwork(params.shortName));
  }, [params.shortName]);

  return (
    <div className="App">
      <Home location={location} />
    </div>
  );
}

App.propTypes = propTypes;

export default App;
